/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import PropTypes from 'prop-types';

class BoxComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = { open: false };
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleToggle(e) {
    e.preventDefault();
    const { open } = this.state;
    if (open) {
      this.setState({ open: false });
    } else {
      this.setState({ open: true });
    }
  }

  render() {
    const { open } = this.state;
    const { activity } = this.props;
    let classNames = 'column large-4 medium-4 small-12 gym-activity';
    if (open) {
      classNames += ' open';
    }

    const type = (() => {
      if (activity.Type !== null) {
        return (
          <span>
            {activity.Type}
          </span>
        );
      }
      return null;
    })();

    const location = (() => {
      if (activity.Location !== null) {
        return (
          <li className="location">
            <span>
              {'Sted: '}
            </span>
            {activity.Location}
          </li>
        );
      }
      return null;
    })();

    const occurrence = (() => {
      if (activity.Occurrence !== null) {
        return (
          <li>
            <span>
              {'Tidspunkt: '}
            </span>
            {activity.Occurrence}
          </li>
        );
      }
      return null;
    })();

    const subCategory = (() => {
      if (activity.SubCategory !== null) {
        return (
          <li>
            <span>
              {'Aktivitet: '}
            </span>
            {activity.SubCategory}
          </li>
        );
      }
      return null;
    })();

    const target = (() => {
      if (activity.Target !== null) {
        return (
          <li className="target">
            <span>
              {'Målgruppe: '}
            </span>
            {activity.Target}
          </li>
        );
      }
      return null;
    })();

    const price = (() => {
      if (activity.Price !== null && activity.Price !== '' && activity.Associations.filter((x) => x === 628).length === 0) {
        return (
          <li className="price">
            <span>
              {'Pris: '}
            </span>
            {activity.Price}
          </li>
        );
      }
      return null;
    })();

    return (
      <div className={classNames}>
        <div>
          {type}
          <h2>
            <a href={activity.Url} target="_blank">
              {activity.NameTrim}
            </a>
          </h2>
          {(() => {
            if (activity.Description != null) {
              return (
                <div dangerouslySetInnerHTML={{ __html: `<p>${activity.Description}</p>` }} />
              );
            }
            return null;
          })()}
          <ul>
            {subCategory}
            {target}
            {location}
            {occurrence}
            {price}
          </ul>
          <p>
            <a href={activity.Url}>
              Læs mere
            </a>
          </p>
          <span>
            <button type="button" onClick={this.handleToggle} />
          </span>
          <span />
        </div>
      </div>
    );
  }
}

BoxComponent.propTypes = {
  activity: PropTypes.shape({
    AllSubjects: PropTypes.bool.isRequired,
    Associations: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
    Description: PropTypes.string,
    EndDate: PropTypes.string,
    ID: PropTypes.number.isRequired,
    Location: PropTypes.string,
    Name: PropTypes.string.isRequired,
    NameTrim: PropTypes.string.isRequired,
    Occurrence: PropTypes.string,
    Price: PropTypes.string,
    Provider: PropTypes.string,
    SubCategory: PropTypes.string,
    Subject: PropTypes.string,
    Target: PropTypes.string,
    Type: PropTypes.string.isRequired,
    Url: PropTypes.string.isRequired,
  }).isRequired,
};

BoxComponent.displayName = 'BoxComponent';
export default BoxComponent;
